module.exports = __webpack_public_path__ + "img/header-weddingRingsRosegold@2x.2160b1f.webp";